import { TemplateDefinition, PageSection } from '../types';

export const TEMPLATES: TemplateDefinition[] = [
  // =========================================================================
  // CORPORATE 1: Corporate Modern (Apex Global Enterprise)
  // =========================================================================
  {
    id: 'corp-apex',
    name: 'Corporate Modern (Apex Global)',
    industry: 'CORPORATE',
    description: 'Büyük ölçekli kurumsal şirketler, holdingler ve finansal danışmanlık kuruluşları için güven veren modern, teknolojik ve prestijli kurumsal tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0F172A',
    secondaryColor: '#334155',
    accentColor: '#2563EB',
    fontFamily: 'Inter, system-ui, sans-serif',
    headingFont: 'Plus Jakarta Sans, sans-serif',
    tags: ['Kurumsal', 'Modern', 'Holding', 'Danışmanlık', 'Finans'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Apex Global — Stratejik Danışmanlık ve Kurumsal Çözümler',
        seoDescription: 'Uluslararası standartlarda kurumsal dönüşüm, finansal mühendislik ve stratejik yönetim danışmanlığı.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-header-1',
            type: 'HEADER',
            name: 'Üst Navigasyon Menüsü',
            isVisible: true,
            content: {
              title: 'Apex Global',
              subtitle: 'Kurumsal Çözümler',
              buttonText: 'İletişime Geçin',
              buttonLink: '/iletisim',
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-hero-1',
            type: 'HERO',
            name: 'Hero Karşılama Alanı',
            isVisible: true,
            content: {
              badge: 'GLOBAL VİZYON & SÜRDÜRÜLEBİLİR BÜYÜME',
              title: 'Geleceğin İş Dünyasını Güvenle İnşa Ediyoruz',
              description: '25 yılı aşkın global deneyimimizle kurumunuzun büyüme stratejilerini ve operasyonel verimliliğini en üst seviyeye taşıyoruz.',
              buttonText: 'Hizmetlerimizi İnceleyin',
              buttonLink: '/hizmetler',
              secondaryButtonText: 'Kurumsal Profilimiz',
              secondaryButtonLink: '/hakkimizda',
              bgImageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 75,
            },
            style: { textColor: '#FFFFFF', paddingTop: '100px', paddingBottom: '100px' },
          },
          {
            id: 'sec-stats-1',
            type: 'STATS',
            name: 'Rakamlarla Başarılarımız',
            isVisible: true,
            content: {
              items: [
                { id: 'st-1', title: '500+', subtitle: 'Tamamlanan Global Proje' },
                { id: 'st-2', title: '$2.4B+', subtitle: 'Yönetilen Varlık Hacmi' },
                { id: 'st-3', title: '%99.2', subtitle: 'Müşteri Memnuniyeti' },
                { id: 'st-4', title: '18 Ülke', subtitle: 'Uluslararası Temsilcilik' },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0F172A' },
          },
          {
            id: 'sec-about-1',
            type: 'ABOUT',
            name: 'Hakkımızda Özeti',
            isVisible: true,
            content: {
              badge: 'BİZ KİMİZ',
              title: 'Yenilikçi Strateji, Disiplinli Uygulama ve Ölçülebilir Sonuçlar',
              description: 'Apex Global olarak pazar dinamiklerini derinlemesine analiz ediyor, kurumların karmaşık zorluklarını stratejik avantaja dönüştürüyoruz. Sektörel bilgi birikimimiz ve çok disiplinli uzman kadromuzla yanınızdayız.',
              imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1200&auto=format&fit=crop',
              buttonText: 'Detaylı Bilgi',
              buttonLink: '/hakkimizda',
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-services-1',
            type: 'SERVICES',
            name: 'Öne Çıkan Hizmetler',
            isVisible: true,
            content: {
              badge: 'UZMANLIK ALANLARIMIZ',
              title: 'İşletmenizi Zirveye Taşıyan Bütünsel Çözümler',
              description: 'Modern iş dünyasının ihtiyaç duyduğu stratejik, finansal ve dijital tüm operasyonları tek çatı altında sunuyoruz.',
              items: [
                {
                  id: 'srv-1',
                  title: 'Stratejik Yönetim Danışmanlığı',
                  description: 'Şirket birleşmeleri, pazar giriş stratejileri ve kurumsal yeniden yapılanma süreçleri.',
                  icon: 'Compass',
                },
                {
                  id: 'srv-2',
                  title: 'Kurumsal Finans & Risk Yönetimi',
                  description: 'Sermaye yapısı optimizasyonu, nakit akışı modellemesi ve risk analitiği sistemleri.',
                  icon: 'TrendingUp',
                },
                {
                  id: 'srv-3',
                  title: 'Dijital Dönüşüm & Süreç Otomasyonu',
                  description: 'Kurumsal ERP/CRM entegrasyonları ve veriye dayalı karar alma mekanizmaları.',
                  icon: 'Cpu',
                },
                {
                  id: 'srv-4',
                  title: 'Sürdürülebilirlik & ESG Raporlaması',
                  description: 'Karbon ayak izi azaltımı, yeşil mutabakat uyumu ve şeffaf kurumsal yönetişim.',
                  icon: 'ShieldCheck',
                },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0F172A' },
          },
          {
            id: 'sec-references-1',
            type: 'REFERENCES',
            name: 'Referanslarımız ve İş Ortaklarımız',
            isVisible: true,
            content: {
              badge: 'GÜVENİLİR ORTAKLIKLAR',
              title: 'Sektör Liderlerinin Tercihi',
              items: [
                { id: 'ref-1', title: 'Global Tech Corp' },
                { id: 'ref-2', title: 'Nordic Bank & Trust' },
                { id: 'ref-3', title: 'Vanguard Aerospace' },
                { id: 'ref-4', title: 'Solaris Energy Group' },
                { id: 'ref-5', title: 'Meridian Logistics' },
              ],
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-testimonials-1',
            type: 'TESTIMONIALS',
            name: 'Müşteri Yorumları',
            isVisible: true,
            content: {
              badge: 'BAŞARI HİKAYELERİ',
              title: 'Müşterilerimizin Gözünden Apex Global',
              items: [
                {
                  id: 't-1',
                  title: 'Stratejik Büyümemizde Kilit Rol Oynadılar',
                  description: 'Uluslararası pazara açılma sürecimizde Apex Global ekibinin sağladığı veri odaklı danışmanlık operasyonel risklerimizi sıfıra indirdi.',
                  author: 'Ahmet Yılmaz',
                  role: 'CEO, Nexa Endüstri A.Ş.',
                  rating: 5,
                },
                {
                  id: 't-2',
                  title: 'Kurumsal Finansmanda Eşsiz Uzmanlık',
                  description: 'Şirketimizin finansal yapılandırma sürecini 6 ay gibi rekor bir sürede başarıyla tamamladılar. Sonuç odaklı ve disiplinli bir ortaklık.',
                  author: 'Merve Karaca',
                  role: 'CFO, Solaris Enerji',
                  rating: 5,
                },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0F172A' },
          },
          {
            id: 'sec-blog-1',
            type: 'BLOG_PREVIEW',
            name: 'Son Haberler & Makaleler',
            isVisible: true,
            content: {
              badge: 'GÜNCEL YAZILAR',
              title: 'Sektörel Trendler ve Stratejik Analizler',
              description: 'Uzmanlarımızın kaleme aldığı en son pazar araştırmaları, ekonomik öngörüler ve yönetim modelleri.',
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-contact-1',
            type: 'CONTACT',
            name: 'İletişim & Danışmanlık Randevusu',
            isVisible: true,
            content: {
              badge: 'BİZE ULAŞIN',
              title: 'Kurumunuz İçin Yeni Bir Başlangıç Yapın',
              description: 'Projeleriniz ve kurumsal ihtiyaçlarınız için uzman danışmanlarımızla hemen irtibata geçin.',
              buttonText: 'Mesaj Gönder',
            },
            style: { backgroundColor: '#0F172A', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-footer-1',
            type: 'FOOTER',
            name: 'Alt Bilgi (Footer)',
            isVisible: true,
            content: {
              title: 'Apex Global Corporation',
              description: 'Tüm hakları saklıdır. Uluslararası kurumsal yönetim ve danışmanlık standartlarına tam uyumludur.',
              buttonText: 'Gizlilik Politikası',
              buttonLink: '/gizlilik',
            },
            style: { backgroundColor: '#020617', textColor: '#94A3B8' },
          },
        ],
      },
      {
        title: 'Hakkımızda',
        slug: '/hakkimizda',
        seoTitle: 'Hakkımızda — Apex Global Kurumsal Tarihçe ve Değerler',
        seoDescription: 'Apex Global misyonu, vizyonu, yönetim ekibi ve global değerleri hakkında detaylı bilgi edinin.',
        isHomePage: false,
        sections: [
          {
            id: 'sec-about-header',
            type: 'HEADER',
            name: 'Üst Navigasyon Menüsü',
            isVisible: true,
            content: { title: 'Apex Global', buttonText: 'İletişim', buttonLink: '/iletisim' },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-about-hero',
            type: 'HERO',
            name: 'Hakkımızda Başlığı',
            isVisible: true,
            content: {
              badge: 'KURUMSAL KİMLİK',
              title: 'Değer Üreten, Güven İnşa Eden Global Birikim',
              description: 'Çeyrek asırlık tecrübemizle kurumların geleceğini şekillendiriyoruz.',
              bgImageUrl: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 80,
            },
            style: { textColor: '#FFFFFF', paddingTop: '80px', paddingBottom: '80px' },
          },
          {
            id: 'sec-team-1',
            type: 'TEAM',
            name: 'Liderlik Kadromuz',
            isVisible: true,
            content: {
              badge: 'YÖNETİM KURULU',
              title: 'Deneyimli ve Vizyoner Liderler',
              items: [
                {
                  id: 'tm-1',
                  title: 'Dr. Selim Aras',
                  subtitle: 'Yönetim Kurulu Başkanı',
                  description: 'Oxford ve Wharton mezunu, 25 yıllık global M&A tecrübesi.',
                  imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=500&auto=format&fit=crop',
                },
                {
                  id: 'tm-2',
                  title: 'Zeynep Aktaş',
                  subtitle: 'Genel Müdür & Partner',
                  description: 'Finansal mühendislik ve stratejik operasyonlar lideri.',
                  imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=500&auto=format&fit=crop',
                },
                {
                  id: 'tm-3',
                  title: 'Murat Erdem',
                  subtitle: 'Teknoloji ve İnovasyon Direktörü',
                  description: 'Kurumsal dijital sistem ve süreç mimarı.',
                  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=500&auto=format&fit=crop',
                },
              ],
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-about-footer',
            type: 'FOOTER',
            name: 'Alt Bilgi',
            isVisible: true,
            content: { title: 'Apex Global', description: 'Tüm hakları saklıdır.' },
            style: { backgroundColor: '#020617', textColor: '#94A3B8' },
          },
        ],
      },
      {
        title: 'Hizmetlerimiz',
        slug: '/hizmetler',
        seoTitle: 'Hizmetlerimiz — Apex Global Danışmanlık Portföyü',
        seoDescription: 'Yönetim danışmanlığı, kurumsal finansman, risk analitiği ve dijital transformasyon hizmetleri.',
        isHomePage: false,
        sections: [
          {
            id: 'sec-srv-header',
            type: 'HEADER',
            name: 'Üst Navigasyon',
            isVisible: true,
            content: { title: 'Apex Global', buttonText: 'Teklif Alın', buttonLink: '/iletisim' },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-srv-list',
            type: 'SERVICES',
            name: 'Detaylı Hizmetlerimiz',
            isVisible: true,
            content: {
              badge: 'UZMANLIK ALANLARI',
              title: 'Sektörünüze Özel Çözümler',
              description: 'İhtiyaçlarınıza uygun esnek ve ölçülebilir yönetim danışmanlığı paketleri.',
              items: [
                { id: 's-1', title: 'Birleşme ve Devralmalar (M&A)', description: 'Due diligence, değerleme ve entegrasyon yönetimi.' },
                { id: 's-2', title: 'Stratejik Planlama', description: '5 yıllık büyüme yol haritaları ve pazar penetrasyonu.' },
                { id: 's-3', title: 'Operasyonel Mükemmellik', description: 'Süreç optimizasyonu ve maliyet düşürme programları.' },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0F172A' },
          },
          {
            id: 'sec-srv-footer',
            type: 'FOOTER',
            name: 'Alt Bilgi',
            isVisible: true,
            content: { title: 'Apex Global', description: 'Tüm hakları saklıdır.' },
            style: { backgroundColor: '#020617', textColor: '#94A3B8' },
          },
        ],
      },
      {
        title: 'İletişim',
        slug: '/iletisim',
        seoTitle: 'İletişim — Apex Global Danışmanlık ve Ofis Lokasyonları',
        seoDescription: 'Merkez ofislerimiz, telefon, e-posta ve iletişim formumuz aracılığıyla bize ulaşın.',
        isHomePage: false,
        sections: [
          {
            id: 'sec-cnt-header',
            type: 'HEADER',
            name: 'Üst Menü',
            isVisible: true,
            content: { title: 'Apex Global', buttonText: 'Ana Sayfa', buttonLink: '/' },
            style: { backgroundColor: '#FFFFFF', textColor: '#0F172A' },
          },
          {
            id: 'sec-cnt-form',
            type: 'CONTACT',
            name: 'İletişim Formu ve Harita',
            isVisible: true,
            content: {
              badge: 'MERKEZ OFİSLERİMİZ',
              title: 'Bizimle İletişime Geçin',
              description: 'Maslak No:1 Plaza, Kat: 24, Sarıyer / İstanbul | info@apexglobal.com | +90 (212) 800 50 00',
              buttonText: 'Randevu Talebi Gönder',
            },
            style: { backgroundColor: '#0F172A', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-cnt-footer',
            type: 'FOOTER',
            name: 'Alt Bilgi',
            isVisible: true,
            content: { title: 'Apex Global', description: 'Tüm hakları saklıdır.' },
            style: { backgroundColor: '#020617', textColor: '#94A3B8' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // CORPORATE 2: Corporate Premium (Vanguard Capital & Advisory)
  // =========================================================================
  {
    id: 'corp-vanguard',
    name: 'Corporate Premium (Vanguard Advisory)',
    industry: 'CORPORATE',
    description: 'Hukuk büroları, varlık yönetimi, vergi denetim şirketleri ve kurumsal danışmanlar için asil, saygın ve yüksek güven hissi veren koyu lacivert & altın tonlu tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0B132B',
    secondaryColor: '#1C2541',
    accentColor: '#D4AF37',
    fontFamily: 'Inter, system-ui, sans-serif',
    headingFont: 'Playfair Display, serif',
    tags: ['Premium', 'Hukuk', 'Varlık Yönetimi', 'Altın Vurgu', 'Saygın'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Vanguard Advisory — Haklarınızı ve Varlıklarınızı Koruyoruz',
        seoDescription: 'Ticaret hukuku, uluslararası tahkim, varlık yönetimi ve kurumsal danışmanlık hizmetleri.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-v-header',
            type: 'HEADER',
            name: 'Vanguard Üst Menü',
            isVisible: true,
            content: { title: 'Vanguard Partners', subtitle: 'Hukuk & Stratejik Varlık Yönetimi', buttonText: 'Randevu Alın', buttonLink: '/iletisim' },
            style: { backgroundColor: '#0B132B', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-v-hero',
            type: 'HERO',
            name: 'Hero Alanı',
            isVisible: true,
            content: {
              badge: 'GÜVEN, ETİK VE PRESTİJ',
              title: 'Köklü Birikimle Kurumunuzun Geleceğini Güvence Altına Alıyoruz',
              description: 'Karmaşık hukuki ihtilaflarda, uluslararası tahkimde ve yüksek hacimli ticari sözleşmelerde yanınızdayız.',
              buttonText: 'Çalışma Alanlarımız',
              buttonLink: '/hizmetler',
              bgImageUrl: 'https://images.unsplash.com/photo-1453728013993-6d66e9c9123a?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 85,
            },
            style: { textColor: '#FFFFFF', paddingTop: '110px', paddingBottom: '110px' },
          },
          {
            id: 'sec-v-about',
            type: 'ABOUT',
            name: 'Kurumsal Yaklaşım',
            isVisible: true,
            content: {
              badge: '30 YILLIK PRESTİJLİ TECRÜBE',
              title: 'Tavizsiz Etik Değerler ve Kusursuz Yönetişim',
              description: 'Vanguard Partners olarak her müvekkilimizin davasını ve varlığını kendi itibarımız gibi sahipleniyoruz. Önleyici hukuki ve finansal danışmanlık ile riskleri önceden bertaraf ediyoruz.',
              imageUrl: 'https://images.unsplash.com/photo-1450133064473-71024230f91b?q=80&w=1200&auto=format&fit=crop',
              buttonText: 'Ekibimizi Tanıyın',
              buttonLink: '/hakkimizda',
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#0B132B' },
          },
          {
            id: 'sec-v-services',
            type: 'SERVICES',
            name: 'Çalışma Alanlarımız',
            isVisible: true,
            content: {
              badge: 'UZMANLIKLAR',
              title: 'Kapsamlı Hukuki ve Finansal Çözümler',
              items: [
                { id: 'vs-1', title: 'Ticaret ve Şirketler Hukuku', description: 'Genel kurul işlemleri, hisse devirleri ve şirket ana sözleşmeleri.' },
                { id: 'vs-2', title: 'Uluslararası Tahkim & Dava', description: 'ICC, LCIA ve ISTAC nezdinde uyuşmazlık çözümleri.' },
                { id: 'vs-3', title: 'Fikri Mülkiyet & Patent', description: 'Marka tescilleri, telif hakları ve lisans sözleşmeleri.' },
                { id: 'vs-4', title: 'Gayrimenkul & İmar Hukuku', description: 'Mega projeler, kat karşılığı inşaat sözleşmeleri ve kentsel dönüşüm.' },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0B132B' },
          },
          {
            id: 'sec-v-contact',
            type: 'CONTACT',
            name: 'Randevu Talebi',
            isVisible: true,
            content: {
              badge: 'GİZLİLİK VE GÜVENCE',
              title: 'Hukuki Danışmanlık ve Ön Görüşme',
              description: 'Zorlu davalarınız ve stratejik yatırımlarınız için uzman ortaklarımızla gizlilik esasına dayalı ilk görüşmeyi planlayın.',
              buttonText: 'Görüşme Talep Edin',
            },
            style: { backgroundColor: '#0B132B', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-v-footer',
            type: 'FOOTER',
            name: 'Alt Bilgi',
            isVisible: true,
            content: { title: 'Vanguard Partners LLP', description: 'Tüm hakları saklıdır. Baro levhasına kayıtlıdır.' },
            style: { backgroundColor: '#050B17', textColor: '#94A3B8' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // CORPORATE 3: Corporate Minimal (Studio Horizon Architecture)
  // =========================================================================
  {
    id: 'corp-minimal',
    name: 'Corporate Minimal (Studio Horizon)',
    industry: 'CORPORATE',
    description: 'Mimarlık ofisleri, tasarım stüdyoları, modern sanat galerileri ve minimalist markalar için monokrom, ferah ve görsel odaklı tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#18181B',
    secondaryColor: '#27272A',
    accentColor: '#52525B',
    fontFamily: 'Inter, sans-serif',
    headingFont: 'Outfit, sans-serif',
    tags: ['Minimalist', 'Mimarlık', 'Tasarım', 'Monokrom', 'Modern'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Studio Horizon — Çağdaş Mimarlık ve Mekan Tasarımı',
        seoDescription: 'Zamansız çizgiler, doğal malzemeler ve fonksiyonel mimari projeler.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-min-header',
            type: 'HEADER',
            name: 'Minimal Header',
            isVisible: true,
            content: { title: 'Studio Horizon', subtitle: 'Architecture & Design', buttonText: 'Projelerimiz', buttonLink: '/hizmetler' },
            style: { backgroundColor: '#FFFFFF', textColor: '#18181B' },
          },
          {
            id: 'sec-min-hero',
            type: 'HERO',
            name: 'Hero Alanı',
            isVisible: true,
            content: {
              badge: 'FONKSİYON & ESTETİK',
              title: 'Mekana Değer Katan Zamansız ve Sürdürülebilir Çizgiler',
              description: 'Doğal ışık, yalın formlar ve kusursuz detay mühendisliği ile geleceğin yaşam alanlarını tasarlıyoruz.',
              buttonText: 'Portföyü İnceleyin',
              buttonLink: '/hizmetler',
              bgImageUrl: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 60,
            },
            style: { textColor: '#FFFFFF', paddingTop: '120px', paddingBottom: '120px' },
          },
          {
            id: 'sec-min-about',
            type: 'ABOUT',
            name: 'Tasarım Felsefesi',
            isVisible: true,
            content: {
              badge: 'YALINLIK & DETAY',
              title: 'Az Çoktur İlkesiyle Şekillenen Çağdaş Mekanlar',
              description: 'Karmaşadan uzak, insan odaklı ve çevreyle uyumlu mimari projeler geliştiriyoruz. Her yapımız bulunduğu coğrafyanın dokusuyla bütünleşir.',
              imageUrl: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=1200&auto=format&fit=crop',
              buttonText: 'Hakkımızda',
              buttonLink: '/hakkimizda',
            },
            style: { backgroundColor: '#FAFAFA', textColor: '#18181B' },
          },
          {
            id: 'sec-min-services',
            type: 'SERVICES',
            name: 'Hizmet Alanlarımız',
            isVisible: true,
            content: {
              badge: 'DİSİPLİNLER',
              title: 'Uçtan Uca Mimari ve İç Mekan Yönetimi',
              items: [
                { id: 'ms-1', title: 'Konsept & Mimari Proje', description: '3D görselleştirme, ruhsat projeleri ve sürdürülebilir malzeme seçimi.' },
                { id: 'ms-2', title: 'İç Mekan & Özel Mobilya', description: 'Akustik konfor, özel aydınlatma ve lüks iç mekan uygulamaları.' },
                { id: 'ms-3', title: 'Uygulama & Şantiye Denetimi', description: 'Sıfır hata toleranslı anahtar teslim proje taahhüdü.' },
              ],
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#18181B' },
          },
          {
            id: 'sec-min-footer',
            type: 'FOOTER',
            name: 'Footer',
            isVisible: true,
            content: { title: 'Studio Horizon Architecture', description: 'İstanbul • Berlin • Londra' },
            style: { backgroundColor: '#18181B', textColor: '#A1A1AA' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // CORPORATE 4: Corporate Business (NovaTech Cloud Solutions)
  // =========================================================================
  {
    id: 'corp-novatech',
    name: 'Corporate Business (NovaTech IT)',
    industry: 'CORPORATE',
    description: 'B2B SaaS, yazılım, bulut bilişim ve kurumsal IT altyapı sağlayıcıları için yüksek tempolu, dinamik elektrik mavisi ve derin lacivert renk şeması.',
    thumbnail: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0B192C',
    secondaryColor: '#1E3E62',
    accentColor: '#00ADB5',
    fontFamily: 'Inter, sans-serif',
    headingFont: 'Plus Jakarta Sans, sans-serif',
    tags: ['Teknoloji', 'SaaS', 'Yazılım', 'Bulut', 'B2B'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'NovaTech — Yeni Nesil Kurumsal Bulut ve Veri Çözümleri',
        seoDescription: 'Kurumunuzun dijital altyapısını modernize eden yüksek güvenlikli bulut ve siber güvenlik hizmetleri.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-nt-header',
            type: 'HEADER',
            name: 'NovaTech Header',
            isVisible: true,
            content: { title: 'NovaTech Cloud', subtitle: 'Kurumsal IT Sistemleri', buttonText: 'Ücretsiz Demo', buttonLink: '/iletisim' },
            style: { backgroundColor: '#0B192C', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-nt-hero',
            type: 'HERO',
            name: 'Hero Teknoloji',
            isVisible: true,
            content: {
              badge: 'YÜKSEK PERFORMANS & SIFIR KESİNTİ',
              title: 'İşletmenizin Dijital Omurgasını Güçlendiriyoruz',
              description: 'Uçtan uca bulut mimarisi, siber güvenlik denetimleri ve yapay zeka destekli kurumsal süreç otomasyonları.',
              buttonText: 'Platformu İnceleyin',
              buttonLink: '/hizmetler',
              secondaryButtonText: 'Teknik Dokümantasyon',
              secondaryButtonLink: '/hakkimizda',
              bgImageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 80,
            },
            style: { textColor: '#FFFFFF', paddingTop: '100px', paddingBottom: '100px' },
          },
          {
            id: 'sec-nt-stats',
            type: 'STATS',
            name: 'Sistem Metrikleri',
            isVisible: true,
            content: {
              items: [
                { id: 'ns-1', title: '%99.99', subtitle: 'Hizmet Süresi (SLA)' },
                { id: 'ns-2', title: '12M+', subtitle: 'Günlük API İsteği' },
                { id: 'ns-3', title: '<15ms', subtitle: 'Global Yanıt Süresi' },
                { id: 'ns-4', title: 'ISO 27001', subtitle: 'Uluslararası Sertifikasyon' },
              ],
            },
            style: { backgroundColor: '#1E3E62', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-nt-services',
            type: 'SERVICES',
            name: 'Teknoloji Çözümlerimiz',
            isVisible: true,
            content: {
              badge: 'ÇÖZÜM MODÜLLERİ',
              title: 'Gelişmiş Kurumsal Teknoloji Yığını',
              items: [
                { id: 'nts-1', title: 'Bulut Altyapı & Kubernetes', description: 'Otomatik ölçeklenen mikroservis mimarileri ve kesintisiz dağıtım.' },
                { id: 'nts-2', title: 'Siber Güvenlik & SOC', description: '7/24 tehdit izleme, sızma testleri ve veri şifreleme protokolleri.' },
                { id: 'nts-3', title: 'Veri Analitiği & BI', description: 'Büyük veri ambarları ve gerçek zamanlı yönetici kontrol panelleri.' },
              ],
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#0B192C' },
          },
          {
            id: 'sec-nt-footer',
            type: 'FOOTER',
            name: 'NovaTech Footer',
            isVisible: true,
            content: { title: 'NovaTech Cloud Solutions Inc.', description: 'Tüm hakları saklıdır. Güvenli bulut altyapısı.' },
            style: { backgroundColor: '#050C16', textColor: '#94A3B8' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // CORPORATE 5: Corporate Creative (Pulse Media Agency)
  // =========================================================================
  {
    id: 'corp-pulse',
    name: 'Corporate Creative (Pulse Agency)',
    industry: 'CORPORATE',
    description: 'Dijital reklam ajansları, medya prodüksiyon şirketleri, halkla ilişkiler ve kreatif stüdyolar için enerjik, koyu zeminli ve mercan/turuncu vurgulu tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0F0F10',
    secondaryColor: '#1F1F22',
    accentColor: '#FF6B6B',
    fontFamily: 'Inter, sans-serif',
    headingFont: 'Montserrat, sans-serif',
    tags: ['Kreatif', 'Ajans', 'Medya', 'Prodüksiyon', 'Marka'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Pulse Creative Agency — Markanıza İlham Veren Dijital Deneyimler',
        seoDescription: 'Kreatif marka kimliği, reklam kampanyaları ve yüksek etkileşimli dijital prodüksiyon.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-p-header',
            type: 'HEADER',
            name: 'Pulse Header',
            isVisible: true,
            content: { title: 'Pulse Creative', subtitle: 'Medya & Marka Ajansı', buttonText: 'Birlikte Üretelim', buttonLink: '/iletisim' },
            style: { backgroundColor: '#0F0F10', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-p-hero',
            type: 'HERO',
            name: 'Hero Kreatif',
            isVisible: true,
            content: {
              badge: 'CESUR FİKİRLER & ÖDÜLLÜ KAMPANYALAR',
              title: 'Markanızın Hikayesini Milyonlara Ulaştırıyoruz',
              description: 'Görsel sanatları, stratejik hikaye anlatımını ve veriye dayalı dijital pazarlamayı buluşturan yeni nesil kreatif ajans.',
              buttonText: 'Projelerimizi Görün',
              buttonLink: '/hizmetler',
              bgImageUrl: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 75,
            },
            style: { textColor: '#FFFFFF', paddingTop: '110px', paddingBottom: '110px' },
          },
          {
            id: 'sec-p-services',
            type: 'SERVICES',
            name: 'Kreatif Hizmetler',
            isVisible: true,
            content: {
              badge: 'NELER YAPIYORUZ',
              title: 'Markanızı Zirveye Taşıyan Disiplinler',
              items: [
                { id: 'ps-1', title: 'Marka Kimliği & Konsept', description: 'Logo tasarımı, kurumsal kimlik kılavuzu ve marka dili inşası.' },
                { id: 'ps-2', title: 'Video Prodüksiyon & Tanıtım', description: '4K tanıtım filmleri, sosyal medya video serileri ve animasyon.' },
                { id: 'ps-3', title: 'Performans & Dijital Büyüme', description: 'Arama optimizasyonu, web analitiği ve dönüşüm optimizasyonu.' },
              ],
            },
            style: { backgroundColor: '#1F1F22', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-p-footer',
            type: 'FOOTER',
            name: 'Pulse Footer',
            isVisible: true,
            content: { title: 'Pulse Creative Media Ltd.', description: 'Tüm hakları saklıdır. Yaratıcı zihinler kulübü.' },
            style: { backgroundColor: '#080809', textColor: '#8E8E93' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // YACHT RENTAL 1: Yacht Luxury (Azure Majesty Superyachts)
  // =========================================================================
  {
    id: 'yacht-azure',
    name: 'Yacht Luxury (Azure Majesty Superyachts)',
    industry: 'YACHT_RENTAL',
    description: 'Ege ve Akdeniz mavi tur, lüks guletler ve ultra süperyat kiralama filoları için zengin deniz mavisi ve parlak altın dokunuşlu tema.',
    thumbnail: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#032030',
    secondaryColor: '#003554',
    accentColor: '#00A6FB',
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    headingFont: 'Cinzel, serif',
    tags: ['Lüks Süperyat', 'Mavi Tur', 'Bodrum', 'Göcek', 'Mürettebatlı'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Azure Majesty — Lüks Yat ve Gulet Kiralama | Bodrum, Göcek, Marmaris',
        seoDescription: 'Ege ve Akdeniz koylarında unutulmaz mavi yolculuk deneyimi. Özel şefli VIP motoryat ve lüks gulet filomuz ile rezervasyon yapın.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-ya-header',
            type: 'HEADER',
            name: 'Azure Yacht Üst Menü',
            isVisible: true,
            content: {
              title: 'Azure Majesty Charters',
              subtitle: 'VIP Mavi Yolculuk',
              buttonText: 'Rezervasyon Yap',
              buttonLink: '/rezervasyon',
            },
            style: { backgroundColor: '#032030', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-ya-hero',
            type: 'HERO',
            name: 'Hero Deniz Alanı',
            isVisible: true,
            content: {
              badge: 'EXCLUSIVE BLUE VOYAGE EXPERIENCE',
              title: 'Turkuaz Sularda Özgürlüğün ve Lüksün Zirvesini Keşfedin',
              description: 'Bodrum, Göcek, Marmaris ve Fethiye koylarında kişiye özel mürettebatlı ve gurme şefli süperyat kiralama hizmetleri.',
              buttonText: 'Yat Filomuzu Keşfedin',
              buttonLink: '/yatlar',
              secondaryButtonText: 'Hızlı Rezervasyon Talebi',
              secondaryButtonLink: '/rezervasyon',
              bgImageUrl: 'https://images.unsplash.com/photo-1540946485063-a40da27545f8?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 60,
            },
            style: { textColor: '#FFFFFF', paddingTop: '120px', paddingBottom: '120px' },
          },
          {
            id: 'sec-ya-filter',
            type: 'YACHT_FILTER',
            name: 'Yat Hızlı Arama & Filtreleme',
            isVisible: true,
            content: {
              title: 'Hayalinizdeki Seyri Planlayın',
              subtitle: 'Kişi sayısı, kabin tercihi ve bütçenize göre ideal yatı bulun',
            },
            style: { backgroundColor: '#003554', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-ya-fleet',
            type: 'YACHT_FLEET',
            name: 'Öne Çıkan Yat Filomuz',
            isVisible: true,
            content: {
              badge: 'PREMİUM FİLO',
              title: 'Lüks ve Konforun Buluştuğu Seçkin Teknelerimiz',
              description: 'Her biri düzenli bakımlı, 5 yıldızlı otel konforunda hizmet veren özel yapım lüks motoryatlar ve geleneksel guletler.',
              columns: 3,
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#032030' },
          },
          {
            id: 'sec-ya-about',
            type: 'ABOUT',
            name: 'Neden Azure Majesty?',
            isVisible: true,
            content: {
              badge: 'AYRICALIKLARIMIZ',
              title: 'Her Detayı Kusursuz Planlanmış Mavi Yolculuk',
              description: 'Özel şeflerimizin hazırladığı Ege lezzetleri, su sporları ekipmanları, VIP transfer ve kişiye özel rota danışmanlığı ile hayallerinizi gerçeğe dönüştürüyoruz.',
              imageUrl: 'https://images.unsplash.com/photo-1569263979104-865ab7cd8d17?q=80&w=1200&auto=format&fit=crop',
              buttonText: 'Hizmet Standartlarımız',
              buttonLink: '/hakkimizda',
            },
            style: { backgroundColor: '#FFFFFF', textColor: '#032030' },
          },
          {
            id: 'sec-ya-cta',
            type: 'RESERVATION_CTA',
            name: 'Rezervasyon Çağrısı',
            isVisible: true,
            content: {
              badge: 'ERKEN REZERVASYON FIRSATLARI',
              title: 'Bu Yaz Unutulmaz Bir Mavi Yolculuğa Hazır mısınız?',
              description: 'İstediğiniz tarihler için müsaitlik durumunu sorgulayın, özel indirim ve ikram paketlerimizden yararlanın.',
              buttonText: 'Rezervasyon Formunu Doldurun',
              buttonLink: '/rezervasyon',
            },
            style: { backgroundColor: '#032030', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-ya-footer',
            type: 'FOOTER',
            name: 'Azure Footer',
            isVisible: true,
            content: {
              title: 'Azure Majesty Yacht Charters',
              description: 'Tüm hakları saklıdır. Ulaştırma ve Altyapı Bakanlığı belgeli deniz turizmi işletmesi.',
            },
            style: { backgroundColor: '#011018', textColor: '#94A3B8' },
          },
        ],
      },
      {
        title: 'Yat Filomuz',
        slug: '/yatlar',
        seoTitle: 'Kiralık Yatlar & Guletler — Azure Majesty Filo Kataloğu',
        seoDescription: 'Bodrum ve Göcek çıkışlı kiralık motoryat, süperyat ve lüks guletlerin teknik özellikleri ve fiyatları.',
        isHomePage: false,
        sections: [
          {
            id: 'sec-yf-header',
            type: 'HEADER',
            name: 'Header',
            isVisible: true,
            content: { title: 'Azure Majesty', buttonText: 'Rezervasyon', buttonLink: '/rezervasyon' },
            style: { backgroundColor: '#032030', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-yf-fleet',
            type: 'YACHT_FLEET',
            name: 'Tüm Yat Listesi',
            isVisible: true,
            content: {
              badge: 'SEÇKİN FİLO',
              title: 'Kiralık Yat ve Gulet Kataloğumuz',
              description: 'Tüm teknelerimiz mürettebatlı olup günlük ve haftalık kiralama seçeneklerine uygundur.',
            },
            style: { backgroundColor: '#F8FAFC', textColor: '#032030' },
          },
          {
            id: 'sec-yf-footer',
            type: 'FOOTER',
            name: 'Footer',
            isVisible: true,
            content: { title: 'Azure Majesty', description: 'Tüm hakları saklıdır.' },
            style: { backgroundColor: '#011018', textColor: '#94A3B8' },
          },
        ],
      },
      {
        title: 'Rezervasyon Talebi',
        slug: '/rezervasyon',
        seoTitle: 'Yat Kiralama Rezervasyonu — Azure Majesty Müsaitlik Formu',
        seoDescription: 'Tarih, kişi sayısı ve istediğiniz yatı seçerek hemen ön rezervasyon talebi oluşturun.',
        isHomePage: false,
        sections: [
          {
            id: 'sec-yr-header',
            type: 'HEADER',
            name: 'Header',
            isVisible: true,
            content: { title: 'Azure Majesty', buttonText: 'Yatlar', buttonLink: '/yatlar' },
            style: { backgroundColor: '#032030', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-yr-form',
            type: 'CONTACT',
            name: 'Rezervasyon Talep Formu',
            isVisible: true,
            content: {
              badge: 'MÜSAİTLİK VE FİYAT TEKLİFİ',
              title: 'Mavi Tur Rezervasyon Formu',
              description: 'Ekibimiz talebinizi aldıktan sonra 30 dakika içerisinde müsaitlik ve özel fiyat teklifi ile sizinle iletişime geçecektir.',
              buttonText: 'Rezervasyon Talebini Gönder',
            },
            style: { backgroundColor: '#032030', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-yr-footer',
            type: 'FOOTER',
            name: 'Footer',
            isVisible: true,
            content: { title: 'Azure Majesty', description: 'Tüm hakları saklıdır.' },
            style: { backgroundColor: '#011018', textColor: '#94A3B8' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // YACHT RENTAL 2: Yacht Mediterranean (Poseidon Aegean Charters)
  // =========================================================================
  {
    id: 'yacht-poseidon',
    name: 'Yacht Mediterranean (Poseidon Aegean)',
    industry: 'YACHT_RENTAL',
    description: 'Bodrum, Marmaris, Datça ve Yunan Adaları rotalarında geleneksel ahşap guletler ve aile dostu yelkenli turları için sıcak kum & turkuaz teması.',
    thumbnail: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0C4A6E',
    secondaryColor: '#0369A1',
    accentColor: '#0EA5E9',
    fontFamily: 'Inter, sans-serif',
    headingFont: 'Plus Jakarta Sans, sans-serif',
    tags: ['Ege', 'Akdeniz', 'Gulet Charter', 'Yunan Adaları', 'Aile Dostu'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Poseidon Aegean — Ege ve Akdeniz Gulet ve Yat Kiralama',
        seoDescription: 'Geleneksel Bodrum guletleri ile koy koy mavi yolculuk turları.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-pos-header',
            type: 'HEADER',
            name: 'Poseidon Header',
            isVisible: true,
            content: { title: 'Poseidon Aegean Charters', subtitle: 'Geleneksel Ege Mavi Yolculuk', buttonText: 'Rezervasyon', buttonLink: '/rezervasyon' },
            style: { backgroundColor: '#FFFFFF', textColor: '#0C4A6E' },
          },
          {
            id: 'sec-pos-hero',
            type: 'HERO',
            name: 'Hero Ege',
            isVisible: true,
            content: {
              badge: 'EGE\'NİN EN GÜZEL KOYLARINDA',
              title: 'Masmavi Bir Tatil, Dinginlik ve Eşsiz Anılar',
              description: 'Geleneksel ahşap guletlerimiz ve konforlu motoryatlarımızla sevdiklerinizle unutulmaz bir mavi tura yelken açın.',
              buttonText: 'Gulet ve Yat Filosu',
              buttonLink: '/yatlar',
              bgImageUrl: 'https://images.unsplash.com/photo-1506929562872-bb421503ef21?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 55,
            },
            style: { textColor: '#FFFFFF', paddingTop: '110px', paddingBottom: '110px' },
          },
          {
            id: 'sec-pos-fleet',
            type: 'YACHT_FLEET',
            name: 'Kiralık Guletler & Tekneler',
            isVisible: true,
            content: {
              badge: 'SEÇKİN GULETLERİMİZ',
              title: 'Ahşabın Sıcaklığı, Denizin Huzuru',
              description: 'Klimalı geniş kabinler, ferah güneşlenme güverteleri ve usta denizcilerden oluşan güler yüzlü mürettebat.',
            },
            style: { backgroundColor: '#F0F9FF', textColor: '#0C4A6E' },
          },
          {
            id: 'sec-pos-footer',
            type: 'FOOTER',
            name: 'Poseidon Footer',
            isVisible: true,
            content: { title: 'Poseidon Aegean Charters', description: 'Bodrum • Marmaris • Fethiye • Kaş' },
            style: { backgroundColor: '#082F49', textColor: '#BAE6FD' },
          },
        ],
      },
    ],
  },

  // =========================================================================
  // YACHT RENTAL 3: Yacht Premium (Nautilus Deluxe Cruising)
  // =========================================================================
  {
    id: 'yacht-nautilus',
    name: 'Yacht Premium (Nautilus Deluxe Cruising)',
    industry: 'YACHT_RENTAL',
    description: 'İstanbul Boğazı kurumsal etkinlikleri, lüks motoryat davetleri ve Akdeniz mega yat organizasyonları için gece mavisi ve şık altın dokulu tasarım.',
    thumbnail: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=1200&auto=format&fit=crop',
    primaryColor: '#0A0E17',
    secondaryColor: '#131B2E',
    accentColor: '#E5A93B',
    fontFamily: 'Inter, sans-serif',
    headingFont: 'Playfair Display, serif',
    tags: ['Mega Yat', 'Boğaz Turu', 'Kurumsal Davet', 'Lüks Motoryat'],
    defaultPages: [
      {
        title: 'Ana Sayfa',
        slug: '/',
        seoTitle: 'Nautilus Deluxe — VIP Yat Kiralama ve Özel Organizasyonlar',
        seoDescription: 'İstanbul Boğazı ve Akdeniz kıyılarında birinci sınıf motoryat kiralama.',
        isHomePage: true,
        sections: [
          {
            id: 'sec-nau-header',
            type: 'HEADER',
            name: 'Nautilus Header',
            isVisible: true,
            content: { title: 'Nautilus Deluxe Cruising', subtitle: 'VIP Yat Hizmetleri', buttonText: 'Hemen Teklif Al', buttonLink: '/rezervasyon' },
            style: { backgroundColor: '#0A0E17', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-nau-hero',
            type: 'HERO',
            name: 'Hero Nautilus',
            isVisible: true,
            content: {
              badge: 'PREMIUM CRUISE & LUXURY EVENTS',
              title: 'Deniz Üzerinde Kusursuz Prestij ve Ayrıcalıklı Yaşam',
              description: 'İster Boğaz\'da iş yemeği, ister Ege\'de 1 haftalık VIP süperyat tatili. Nautilus standartlarında en üst düzey konfor.',
              buttonText: 'Yatları İnceleyin',
              buttonLink: '/yatlar',
              bgImageUrl: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=1600&auto=format&fit=crop',
              bgOverlayOpacity: 65,
            },
            style: { textColor: '#FFFFFF', paddingTop: '120px', paddingBottom: '120px' },
          },
          {
            id: 'sec-nau-fleet',
            type: 'YACHT_FLEET',
            name: 'Nautilus Filosu',
            isVisible: true,
            content: {
              badge: 'PREMİUM KOLEKSİYON',
              title: 'Modern Motoryatlar ve Süperyatlar',
              description: 'Ödüllü iç mekan tasarımları, son teknoloji ses ve navigasyon sistemleri.',
            },
            style: { backgroundColor: '#131B2E', textColor: '#FFFFFF' },
          },
          {
            id: 'sec-nau-footer',
            type: 'FOOTER',
            name: 'Nautilus Footer',
            isVisible: true,
            content: { title: 'Nautilus Deluxe Cruising Inc.', description: 'Bebek • Göcek • Monaco' },
            style: { backgroundColor: '#05070B', textColor: '#94A3B8' },
          },
        ],
      },
    ],
  },
];
